import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '@/views/Main';
import LatestJobs from '@/components/LatestJobs';
import JobsTable from '@/components/JobsTable';
import SamplesTable from '@/components/SamplesTable';
import ResultsTable from '@/components/ResultsTable';
import Settings from '@/components/Settings';
import Users from '@/components/Users';
import Contact from '@/components/Contact';
import JobDetail from '@/components/JobDetail';
import SampleDetail from '@/components/SampleDetail';
import Login from '@/views/Login';
import ResetPassword from '@/views/ResetPassword';
import ResetPasswordRedemption from '@/views/ResetPasswordRedemption';
import NotFound from '@/views/NotFound';

import {
  tokenAuth
} from '@/middleware/auth';
import {
  logout
} from "@/services/api";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: async (to, from, next) => {
        await logout();
        next('/login');
      }
    },
    {
      path: '/',
      redirect: '/overview',
      component: Main,
      children: [{
          path: 'overview',
          name: 'Overview',
          component: LatestJobs,
          props: true,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'jobs',
          name: 'Jobs',
          component: JobsTable,
          props: true,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'jobs/:id',
          name: 'Job Detail',
          component: JobDetail,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'jobs/:jobId/samples/:sampleId',
          name: 'Sample Detail',
          component: SampleDetail,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'results',
          name: 'Results',
          component: ResultsTable,
          props: true,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'samples',
          name: 'Samples',
          component: SamplesTable,
          props: true,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: Users,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact,
          beforeEnter: (to, from, next) => {
            return tokenAuth(router, next);
          }
        }
      ],
      beforeEnter: (to, from, next) => {
        if (to.query.path) {
          const nextPath = to.query.path;
          delete to.query.path;
          next({
            path: nextPath,
            query: to.query
          });
        } else {
          return tokenAuth(router, next);
        }
      }
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/set-password',
      name: 'ResetPasswordRedemption',
      component: ResetPasswordRedemption
    },
    // Fall through 404 page
    {
      path: '*',
      name: 'Page Not Found',
      component: NotFound
    }
  ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js